import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrganizationService } from './organization.service';

@Injectable()
export class OrganizationInterceptor implements HttpInterceptor {
  private organizationService = inject(OrganizationService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const orgId = this.organizationService.selectedOrg();

    if (orgId) {
      const cloned = req.clone({
        setHeaders: {
          'X-Organization-Id': orgId,
        },
      });
      return next.handle(cloned);
    }

    return next.handle(req);
  }
}
